import clsx from "clsx";
import { Link } from "react-router-dom";
import { IMenuLinkProps } from "./";

const MenuLink = ({
  path,
  newTab,
  hasItemSub = false,
  externalLink,
  className,
  handleToggle,
  handleClick,
  tabIndex,
  "aria-label": ariaLabel,
  children,
}: IMenuLinkProps) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (hasItemSub && handleToggle) {
        handleToggle(e as unknown as React.MouseEvent<HTMLElement>);
      } else if (path && !hasItemSub) {
        // For navigation items, trigger a click on the element to activate React Router
        (e.currentTarget as HTMLElement).click();
      } else if (handleClick) {
        handleClick(e as unknown as React.MouseEvent<HTMLElement>);
      }
    }
  };

  if (!hasItemSub && path) {
    if (externalLink) {
      const target = newTab ? "_blank" : "_self";

      return (
        <a
          href={path}
          target={target}
          rel="noopener"
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex={tabIndex || 0}
          className={clsx("menu-link", className && className)}
          aria-label={ariaLabel}
        >
          {children}
        </a>
      );
    } else {
      return (
        <Link
          to={path}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex={tabIndex || 0}
          className={clsx("menu-link", className && className)}
          aria-label={ariaLabel}
        >
          {children}
        </Link>
      );
    }
  } else {
    if (hasItemSub) {
      return (
        <div
          className={clsx("menu-link", className && className)}
          onClick={handleToggle}
          onKeyDown={handleKeyDown}
          tabIndex={tabIndex || 0}
          role="button"
          aria-expanded={false}
          aria-label={ariaLabel}
        >
          {children}
        </div>
      );
    } else {
      return (
        <div
          className={clsx("menu-link", className && className)}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
          tabIndex={tabIndex || 0}
          role="button"
          aria-label={ariaLabel}
        >
          {children}
        </div>
      );
    }
  }
};

export { MenuLink };
